// Edit User Admin Page
export const PHONE_NUMBER_REGEXP = /^\([2-9]\d{2}\)\s-\s\d{3}\s-\s\d{4}$/;

// Stall Application Form
export const STREET_ADDRESS_REGEXP = /^[\d\s',.A-Za-z-]+$/;
export const CITY_REGEXP = /^[\s'.A-Za-z-]+$/;
export const POLICY_NUMBER_REGEXP = /^[\d\sA-Za-z]+$/;
export const ONLY_NUMBERS_REGEXP = /^\d+$/;
